export default {
  FETCH_TODOS_REQUEST: "FETCH_TODOS_REQUEST",
  FETCH_TODOS_FAILED: "FETCH_TODOS_FAILED",
  FETCH_TODOS_SUCCESS: "FETCH_TODOS_SUCCESS",
  ADD_TODOS_REQUEST: "ADD_TODOS_REQUEST",
  ADD_TODOS_FAILED: "ADD_TODOS_FAILED",
  ADD_TODOS_SUCCESS: "ADD_TODOS_SUCCESS",
  DELETE_TODOS_REQUEST: "DELETE_TODOS_REQUEST",
  DELETE_TODOS_FAILED: "DELETE_TODOS_FAILED",
  DELETE_TODOS_SUCCESS: "DELETE_TODOS_SUCCESS",
  UPDATE_TODOS_REQUEST: "UPDATE_TODOS_REQUEST",
  UPDATE_TODOS_FAILED: "UPDATE_TODOS_FAILED",
  UPDATE_TODOS_SUCCESS: "UPDATE_TODOS_SUCCESS"
};
